import Button from '@admin/components/button'
import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'

class Badge extends React.Component {

  static contextTypes = {
    host: PropTypes.object,
    portal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    active: PropTypes.bool,
    count: PropTypes.number,
    drawer: PropTypes.object,
    help: PropTypes.bool,
    route: PropTypes.string,
    sidebar: PropTypes.func,
    sound: PropTypes.string,
    svg: PropTypes.string,
    title: PropTypes.string
  }

  state = {
    animate: false
  }

  _handleClick = this._handleClick.bind(this)
  _handleNotify = this._handleNotify.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    const { svg } = this.props
    const count = this._getCount()
    return (
      <Button { ...this._getBadge() }>
        <div className="maha-badge-inner">
          { count &&
            <div { ...this._getLabel() }>{ count}</div>
          }
          { <Icon svg={ svg } /> }
        </div>
      </Button>
    )
  }

  componentDidUpdate(prevProps) {
    const { count } = this.props
    if(count && count > prevProps.count) {
      this._handleNotify()
    }
    if(count !== prevProps.count) {
      this._handleUpdate()
    }
  }

  _getBadge() {
    const { title } = this.props
    return {
      className: 'maha-badge',
      event: `clicked '${title}' badge`,
      handler: this._handleClick,
      tooltip: {
        title: title,
        position:'right center'
      }
    }
  }

  _getCount() {
    const { count } = this.props
    if(!count) return null
    return count > 99 ? '99+' : count
  }

  _getLabel() {
    const { animate } = this.state
    const { count } = this.props
    const classes = ['maha-badge-label']
    if(animate) classes.push('animating transition tada')
    return {
      className: classes.join(' '),
      title: `${count} unread`
    }
  }

  _handleClick() {
    const { drawer, help, sidebar, route } = this.props
    const desktop = document.body.clientWidth <= 1024
    if(desktop && route) return this.context.router.push(route)
    if(drawer) return this.context.portal.setDrawer(drawer.component, drawer.width)
    if(sidebar) return this.context.portal.setSidebar(sidebar)
    if(help) return this.context.portal.toggleHelp()
    if(route) this.context.router.push(route)
  }

  _handleNotify() {
    this.setState({ animate: true })
    const audio = new Audio('/audio/notification.mp3') 
    audio.play()
    setTimeout(() => {
      this.setState({ animate: false })
    }, 500)
  }

  _handleUpdate() {
    const { count, title } = this.props
    console.log('update', count)
    if(title !== 't(Notifications)') return
    this.context.host.device.setCount(count)
  }

}

export default Badge
